import { GetTwenty47RequestFormResponse } from "src/app/core/output-data/get-twenty47-request-form.response";

export class Twenty47RequestFormViewModel {
   GetTwenty47RequestFormResponse: GetTwenty47RequestFormResponse;
   NewId: string;
}